import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { ClipboardList } from 'lucide-react';
import type { ICustomerPolicyCardProps } from '@/@types/customers';

const STATUS_VARIANTS: Record<string, 'default' | 'secondary' | 'destructive' | 'outline'> = {
  draft: 'secondary',
  active: 'default',
  expired: 'outline',
  cancelled: 'destructive',
};

export function CustomerPolicyCard({
  policyId,
  policyNumber,
  insuranceTypeName,
  status,
  startDate,
  expiryDate,
  totalPremium,
  currency,
}: ICustomerPolicyCardProps) {
  const navigate = useNavigate();

  return (
    <Card
      className="border border-border cursor-pointer hover:border-primary/50 transition-colors"
      onClick={() => navigate(`/insurance/policies/${policyId}`)}
    >
      <CardContent className="p-4">
        <div className="flex items-start justify-between">
          <div className="flex items-center gap-3">
            <div className="rounded-lg bg-muted p-2">
              <ClipboardList className="w-4 h-4 text-muted-foreground" />
            </div>
            <div>
              <p className="text-sm font-medium text-foreground">{policyNumber}</p>
              {insuranceTypeName && (
                <p className="text-xs text-muted-foreground">{insuranceTypeName}</p>
              )}
            </div>
          </div>
          <Badge variant={STATUS_VARIANTS[status] || 'secondary'} className="capitalize">
            {status}
          </Badge>
        </div>
        <div className="mt-3 grid grid-cols-3 gap-2 text-xs text-muted-foreground">
          {startDate && (
            <div>
              <span className="block text-foreground/60">Start</span>
              {startDate}
            </div>
          )}
          {expiryDate && (
            <div>
              <span className="block text-foreground/60">Expiry</span>
              {expiryDate}
            </div>
          )}
          {totalPremium && (
            <div>
              <span className="block text-foreground/60">Premium</span>
              {currency || 'EUR'} {totalPremium}
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
